import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { resultsConfigSelector } from 'ctm-selectors';

import { SimpleFlexbox } from '../flexbox/flexbox';
import { Price } from './price/price';
import { PriceDetails } from './price_details/price_details';

import styles from './quote_price.css';

/**
 * Depending on the frequency type, renders the quote price with additional price information (1st month price, and total)
 */
class _QuotePrice extends PureComponent {

    /**
     * Render the quote price, and additional price information depending on the frequency type
     * @returns {node} QuotePrice - the configured quote price component
     */
    render = () => {
        const { frequency, price, firstMonth, total, inline, priceInline, showFrequencyToggle } = this.props;
        const displayDetails = frequency === 'monthly';
        return (
            <SimpleFlexbox className={styles.container} display="flex" xs={12} gapless="xs" column={!inline} contentCenter="sm" itemsCenter="xs">
                <Price price={price} frequency={frequency} showFrequencyToggle={showFrequencyToggle} />
                {displayDetails && <PriceDetails column={!priceInline} firstMonth={firstMonth} total={total} />}
            </SimpleFlexbox>
        );
    };

}

_QuotePrice.propTypes = {
    frequency: PropTypes.oneOf(['monthly', 'annual']),
    price: PropTypes.number,
    firstMonth: PropTypes.number,
    total: PropTypes.number,
    inline: PropTypes.bool,
    priceInline: PropTypes.bool,
    showFrequencyToggle: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    /**
     * Prepare the quote price and configure the annual / monthly filter flag
     */
    const {
        stateProps: { product }
    } = props;
    const frequency = resultsConfigSelector(state).getIn(['filters', 'frequency']);
    const priceNode = product.getIn(['productMeta', 'price']);

    /* There are some issues when trying to navigate to the more info page from
     * the journey. It tries to read the price but the product is NULL. This is to try
     * and fix this issue. We may need to move the more_info component to be a modal instead.
     * https://jira.budgetdirect.com.au/browse/CTM-1549
    */
    if (!priceNode) {
        return { };
    }

    const price = frequency === 'monthly' ? parseFloat(priceNode.get('monthlyPremium')) : parseFloat(priceNode.get('annualPremium'));
    const firstMonth = parseFloat(priceNode.get('monthlyFirstMonth'));
    const total = parseFloat(priceNode.get('annualisedMonthlyPremium'));

    return {
        frequency,
        price,
        firstMonth,
        total
    };
};

const QuotePrice = connect(mapStateToProps)(_QuotePrice);
export { QuotePrice };
